<template>
    <div class="content">
        <div class="tab-button">
            <div @click="() => { active = 0 }" :class="{'active': active === 0}" class="tab">公告</div>
            <div @click="() => { active = 1 }" :class="{'active': active === 1}" class="tab">文件下载</div>
            <el-button type="primary" icon="el-icon-video-camera-solid" class="btn" @click="toVideoExplain">视频讲解</el-button>
        </div>
        <div class="tab-content">
            <div v-for="(item, index) in list" :key="index" class="notices-item" @click="itemClick(item, index)">
                <div class="des">{{ item.title }}</div>
                <div class="time">{{ item.time }}</div>
            </div>
            <div v-if="!list.length" class="empty">
                <img src="../../assets/empty.png" alt="">
                <div>暂无内容</div>
            </div>
        </div>
        <div class="footer">
            技术支持：中联集团教育科技有限公司  |  联系人：  任老师 18810991825  或（010）88000385  |  本平台仅用于模拟练习使用
        </div>
    </div>
</template>
<script>
import { notices, download } from './index.js'
export default {
    name: 'contents',
    data() {
        return {
            active: 0,
            list: notices
        }
    },
    watch: {
        active: function() {
            this.list = this.active === 0 ? notices : download
        }
    },
    methods: {
        toVideoExplain() {
            const path = this.$router.resolve({
                path: '/videoExplain'
            })
            window.open(path.href, '_blank')
        },
        itemClick(e, i) {
            if (this.active === 0) {
                this.$router.push({
                    path: '/notice',
                    query: {
                        type: i
                    }
                })
                return false
            }
            fetch(e.url + '?t=' + new Date().getTime())
            .then(res => res.blob())
            .then(blob => {
                var a = document.createElement('a')
                a.setAttribute('href', window.URL.createObjectURL(blob))
                a.setAttribute('download', e.title)
                a.click()
            })
            .catch(() => {
                
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.content{
    height: auto;
    position: absolute;
    width: 100%;
    left: 0;
    top: 538px;
    *{
        box-sizing: border-box;
    }
    .tab-button{
        height: 91px;
        backdrop-filter: blur(53px);
        background: linear-gradient(270deg, rgba(0, 0, 0, 0.56) 0%, rgba(0, 0, 0, 0.56) 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .tab{
            width: 260px;
            height: 100%;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0.19) 0%, rgba(255, 255, 255, 0.01) 99.45%);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            backdrop-filter: blur(55px);
            cursor: pointer;
        }
        .btn{
            height: 44px;
            line-height: 44px;
            min-width: 131px;
            padding: 0;
            border-radius: 65px;
            margin-left: 628px;
            .el-icon-video-camera-solid{
                font-size: 18px;
                position: relative;
                top: 1px;
            }
        }
        .active{
            background: linear-gradient(90deg, rgba(109, 178, 252, 0.65) 0%, rgba(23, 134, 251, 0.84) 100%);
        }
    }
}
.tab-content{
    background: rgba(241, 242, 245, 1);
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    padding: 40px 0 90px 0;
    min-height: 780px;
    // flex: 1;
    .notices-item{
        width: 1110px;
        border-radius: 6px;
        height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(180deg, rgba(243, 245, 247, 1) 0%, rgba(243, 245, 247, 1) 9.91%, rgba(254, 254, 255, 1) 100%);
        box-shadow: -7px -7px 7px -2px rgba(255, 255, 255, 0.8), 10px 10px 22px 0px rgba(228, 233, 241, 1);
        margin-bottom: 30px;
        padding: 0 34px;
        border: 1px solid transparent;
        cursor: pointer;
        &:hover{
            border-color: rgba(73, 153, 204, 1);  
        }
        &:last-child{
            margin-bottom: 0;
        }
        .des{
            font-size: 16px;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
        }
        .time{
            font-size: 14px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
        }
    }
    .empty{
        flex: 1;
        padding-top: 47px;
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 18px;
        line-height: 32px;
        color: rgba(0, 0, 0, 1);
        img{
            width: 285px;
            display: block;
            margin-bottom: 37.2px;
        }
    }
}
.footer{
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    // padding: 27px 0 35px 0;
    height: 53px;
    line-height: 53px;
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    width: 100%;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(30px);
}
</style>